import { handleActions } from "redux-actions";
import types from "../types/config";

const INITIAL_STATE = {};

const handleReceiveConfiguration = (state, { payload }) => (payload);

export const config = handleActions({
  [types.CONFIGURATION_RECEIVED]: handleReceiveConfiguration,
}, INITIAL_STATE);

export default config;



// WEBPACK FOOTER //
// ./src/redux/reducers/config.js